import { FaCog } from "react-icons/fa";
import { BiSolidDashboard } from "react-icons/bi";
import { IRouteConfig } from "@lib/types/Routes";
import { ROUTES } from "@lib/constants";
// import { TbZoomMoney } from "react-icons/tb";
import { MdPayments } from "react-icons/md";

const customerRoutesConfig: IRouteConfig[] = [
  {
    id: "dashboards",
    title: "dashboards",
    messageId: "sidebar.dashboards",
    type: "group",
    icon: <BiSolidDashboard />,
    showInBottomNav: false,
    children: [
      {
        id: ROUTES.CUSTOMER.DASHBOARD,
        url: ROUTES.CUSTOMER.DASHBOARD,
        title: "Customer Dashboard",
        messageId: "sidebar.customer.dashboard",
        icon: <BiSolidDashboard />,
        type: "item",
        showInBottomNav: true,
      },
    ],
  },

  {
    id: "payments",
    title: "payments",
    messageId: "sidebar.customer.payments",
    type: "group",
    icon: <BiSolidDashboard />,
    children: [
      // {
      //   id: ROUTES.CUSTOMER.BLOCKCHAIN_PAYMENTS.LIST,
      //   url: ROUTES.CUSTOMER.BLOCKCHAIN_PAYMENTS.LIST,
      //   title: "Blockchain Payments",
      //   messageId: "sidebar.customer.blockchainPayments",
      //   icon: <TbZoomMoney />,
      //   type: "item",
      //   showInBottomNav: true,
      // },
      // {
      //   id: ROUTES.CUSTOMER.CASH_PAYMENT_HISTORY.LIST,
      //   url: ROUTES.CUSTOMER.CASH_PAYMENT_HISTORY.LIST,
      //   title: "Cash Payment History",
      //   messageId: "sidebar.customer.cashPaymentHistory",
      //   icon: <GrMoney />,
      //   type: "item",
      //   showInBottomNav: true,
      // },
      {
        id: ROUTES.CUSTOMER.PAYMENT_HISTORY.LIST,
        url: ROUTES.CUSTOMER.PAYMENT_HISTORY.LIST,
        title: "Payment History",
        messageId: "sidebar.customer.paymentHistory",
        icon: <MdPayments />,
        type: "item",
        showInBottomNav: true,
      },
    ],
  },

  {
    id: ROUTES.CUSTOMER.SETTINGS,
    url: ROUTES.CUSTOMER.SETTINGS,
    title: "Settings",
    messageId: "sidebar.customer.settings",
    icon: <FaCog />,
    type: "item",
    dontShowInSidebar: true,
    showInBottomNav: true,
  },
];

export default customerRoutesConfig;
